import { logUtil } from 'packages/src'
import { updateFromPlatformAppAction } from 'modules/app/actions/updateFromPlatform/index.js'

const FROM_PLATFORM_STORAGE_KEY = 'fromPlatform'
const FROM_PLATFORM_SET_AT_STORAGE_KEY = 'fromPlatformSetAt'
const PLATFORM_EXPIRATION_HOURS = 1

/**
 * Get platform from query parameter or localStorage, persist to localStorage and Redux
 * @param {string|null} platformFromQuery - Platform value from query parameter
 * @returns {Function} Redux thunk
 */
const getFromLocalStorage = () => {
  if (!BROWSER) {
    return null
  }

  try {
    const storedPlatform = window.localStorage.getItem(FROM_PLATFORM_STORAGE_KEY)
    const storedSetAt = window.localStorage.getItem(FROM_PLATFORM_SET_AT_STORAGE_KEY)

    if (!storedPlatform || !storedSetAt) {
      return null
    }

    const setAtTime = parseInt(storedSetAt, 10)
    const currentTime = Date.now()
    const hoursSinceSet = (currentTime - setAtTime) / (1000 * 60 * 60)

    if (hoursSinceSet <= PLATFORM_EXPIRATION_HOURS) {
      logUtil('getAndPersistPlatformAppAction').debug('[retrieved from localStorage] platform=', storedPlatform, 'hoursSinceSet=', hoursSinceSet)
      return storedPlatform
    }

    // Expired, clear from storage
    window.localStorage.removeItem(FROM_PLATFORM_STORAGE_KEY)
    window.localStorage.removeItem(FROM_PLATFORM_SET_AT_STORAGE_KEY)
    logUtil('getAndPersistPlatformAppAction').debug('[expired localStorage] hoursSinceSet=', hoursSinceSet)
    return null
  } catch (error) {
    logUtil('getAndPersistPlatformAppAction').error('[localStorage read error]', error)
    return null
  }
}

const saveToLocalStorage = (platform) => {
  if (!BROWSER) {
    return
  }

  try {
    window.localStorage.setItem(FROM_PLATFORM_STORAGE_KEY, platform)
    window.localStorage.setItem(FROM_PLATFORM_SET_AT_STORAGE_KEY, Date.now().toString())
    logUtil('getAndPersistPlatformAppAction').debug('[saved to localStorage] platform=', platform)
  } catch (error) {
    logUtil('getAndPersistPlatformAppAction').error('[localStorage write error]', error)
  }
}

export const getAndPersistPlatformAppAction = (platformFromQuery) => {
  return (dispatch) => {
    const platform = platformFromQuery || getFromLocalStorage()

    if (!platform) {
      return
    }

    dispatch(updateFromPlatformAppAction(platform))
    saveToLocalStorage(platform)
  }
}
